import React from 'react'
import styles from "./OccasionCard.module.css";
import { Link,useNavigate } from 'react-router-dom';
import { ProductsAPI } from "../../Helpers/ConfigProvider";
function OccasionCard({Id, FriendlyName, Name, Image,Theme, description}) {
  const navigate = useNavigate();

    const handleButtonClick = () => {

        navigate(`/Occasions/${FriendlyName}`);
    }
    const apiUrl =  window.appConfig?.REACT_APP_PRODUCT_API_URL;


    return (
    <div className={styles.polaroid} style={{border: `2px solid ${Theme?.Colour || '#000'}`}} >
         <Link to={`/Occasions/${FriendlyName}`}>
              <div className={styles.Title}>{Name}</div>
              <img
                src={`${ProductsAPI}${Image?.src}`}
                alt={`${ProductsAPI}${Image?.alt}`}
                onError={(e) =>
                  (e.target.src = "/Images/Content/mh-registered.png")}
              />
              <div className={styles.description}>{description}</div>
              <button className={styles.Button} style={{color:Theme.FontColor, backgroundColor:Theme.Colour}} onClick={handleButtonClick}>{Theme.ButtonText}</button>
                
              </Link>
    </div>
    )
}

export default OccasionCard